import { CompRef } from '@wix/document-services-types';
import { PluginsHostApiContext } from '@wix/editor-platform-host-integration-apis';

import {
  PluginManagerImplementationAPIs,
  getAddPluginSteps,
  getRemovePluginSteps,
  PluginAddParams,
  PluginManagerType,
  PluginRemoveParams,
} from './steps';

export function createPluginManager(apis: PluginManagerImplementationAPIs): {
  add: (params: PluginAddParams) => Promise<CompRef>;
  remove: (params: PluginRemoveParams) => Promise<void>;
} {
  const createEditorPluginManager = () => {
    return {
      add: async (params: PluginAddParams) => {
        const steps = getAddPluginSteps(params, apis, 'editor');
        const placement = await steps.getPlacement();
        await steps.biReportAddTry(placement);
        await steps.installPluginAppIfNeeded();
        const compRef = await steps.populate();
        await steps.biReportAddSuccess(placement);
        await steps.postInstallWait();
        await steps.notifyHostApp(placement);
        return compRef;
      },
      remove: async (params: PluginRemoveParams) => {
        const steps = getRemovePluginSteps(params, apis, 'editor');
        const placement = steps.getPlacement();
        steps.removeFromSlot();
        steps.biReportRemoveSuccess(placement);
        steps.notifyHostApp(placement);
      },
    };
  };

  const createBlocksAppPluginManager = () => {
    return {
      add: async (params: PluginAddParams) => {
        const steps = getAddPluginSteps(params, apis, 'blocksAppEditor');
        const placement = await steps.getPlacement();
        await steps.biReportAddTry(placement);
        await steps.installPluginAppIfNeeded();
        const compRef = await steps.populate();
        await steps.biReportAddSuccess(placement);
        return compRef;
      },
      remove: async (params: PluginRemoveParams) => {
        const steps = getRemovePluginSteps(params, apis, 'blocksAppEditor');
        const placement = steps.getPlacement();
        steps.removeFromSlot();
        steps.biReportRemoveSuccess(placement);
        steps.notifyHostApp(placement);
      },
    };
  };

  const createSdkPluginManager = () => {
    return {
      add: async (params: PluginAddParams) => {
        const steps = getAddPluginSteps(params, apis, 'sdk');
        const placement = await steps.getPlacement();
        await steps.biReportAddTry(placement);
        await steps.installPluginAppIfNeeded();
        const compRef = await steps.populate();
        await steps.biReportAddSuccess(placement);
        return compRef;
      },
      remove: async (params: PluginRemoveParams) => {
        const steps = getRemovePluginSteps(params, apis, 'sdk');
        const placement = steps.getPlacement();
        steps.removeFromSlot();
        steps.biReportRemoveSuccess(placement);
        steps.notifyHostApp(placement);
      },
    };
  };
  const managerType = setPluginManagerType(apis.hostApiContext);

  switch (managerType) {
    case 'editor':
      return createEditorPluginManager();
    case 'blocksAppEditor':
      return createBlocksAppPluginManager();
    case 'sdk':
      return createSdkPluginManager();
  }
}

function setPluginManagerType(
  hostApiContext: PluginsHostApiContext,
): PluginManagerType {
  if (
    hostApiContext.origin === 'pluginsPanel' &&
    hostApiContext.action === 'installDefaultPluginInBlocks'
  ) {
    return 'blocksAppEditor';
  }
  if (hostApiContext.origin === 'sdk') {
    return 'sdk';
  }

  return 'editor';
}
